/* eslint-disable sonarjs/no-angular-bypass-sanitization */
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { Pipe, PipeTransform, inject } from '@angular/core';

@Pipe({ name: 'safeHtml' })
export class SafeHtmlPipe implements PipeTransform {
  private sanitized = inject(DomSanitizer);

  /*
   * do not use this pipe for user generated content, this pipe is for labels only
   */
  transform(value): SafeHtml {
    return this.sanitized.bypassSecurityTrustHtml(value);
  }
}
